import { SubSubTitle } from '@components/styled/SubSubTitle.styled';
import { Subtitle } from '@components/styled/Subtitle.styled';
import { Title } from '@components/styled/Title.styled';
import styled from 'styled-components';
import { fontBodyLg, fontHeadingLg } from '../../typography.styled';

export const Header = styled.div`
    ${Title} {
        ${fontHeadingLg}
        text-align: left;
        margin-bottom: 15px;
    }

    ${Subtitle} {
        ${fontBodyLg}
        text-align: left;
    }

    ${SubSubTitle} {
        margin-top: 10px;
    }
`;
